export default __webpack_public_path__ + "static/media/logo-spaider.c3e1ef79.png";